<template>
  <section class="page-panel">
    <header class="page-panel__header"><h3 class="panel-title">Stanje vozila pri preuzimanju</h3></header>
    <div class="page-panel__content grid grid-column-gap-16 grid-row-gap-18">
      <div class="col-12">
        <RecordReadOnlyField v-if="readonly" label="Km stanje" :value="values.pickupMileageKm === '' ? '' : `${values.pickupMileageKm} km`" required />
        <AppTextField v-else :model-value="values.pickupMileageKm" label="Km stanje" placeholder="npr. 45200" type="number" suffix="km" required :rules="mileageRules" @update:model-value="$emit('change', 'pickupMileageKm', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Datum preuzimanja" :value="values.pickupDate ? formatDate(values.pickupDate) : ''" required />
        <AppDateField v-else :model-value="values.pickupDate" label="Datum preuzimanja" required @update:model-value="$emit('change', 'pickupDate', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Vrijeme preuzimanja" :value="values.pickupTime" required />
        <AppTimeField v-else :model-value="values.pickupTime" label="Vrijeme preuzimanja" required @update:model-value="$emit('change', 'pickupTime', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Stanje napunjenosti baterije" :value="values.pickupBatteryPercent === '' ? '' : `${values.pickupBatteryPercent} %`" />
        <AppTextField v-else :model-value="values.pickupBatteryPercent" label="Stanje napunjenosti baterije" type="number" suffix="%" :rules="batteryRules" @update:model-value="$emit('change', 'pickupBatteryPercent', $event)" />
      </div>
      <div class="col-12 col-sm-6">
        <RecordReadOnlyField v-if="readonly" label="Razina goriva u spremniku" :value="values.pickupFuelLevel" />
        <AppTextField v-else :model-value="values.pickupFuelLevel" label="Razina goriva u spremniku" :rules="fuelRules" @update:model-value="$emit('change', 'pickupFuelLevel', $event)" />
      </div>
      <div class="col-12">
        <RecordReadOnlyField v-if="readonly" label="Oštećenja evidentirana kod predaje vozila" :value="values.pickupDamage" />
        <AppTextarea v-else :model-value="values.pickupDamage" label="Oštećenja evidentirana kod predaje vozila" placeholder="Opišite vidljiva oštećenja vozila..." @update:model-value="$emit('change', 'pickupDamage', $event)" />
      </div>
    </div>
  </section>
</template>

<script setup>
import { formatDate } from '../../helpers'
import AppDateField from '../AppDateField.vue'
import AppTextField from '../AppTextField.vue'
import AppTextarea from '../AppTextarea.vue'
import AppTimeField from '../AppTimeField.vue'
import RecordReadOnlyField from './RecordReadOnlyField.vue'

defineProps({
  values: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
})

defineEmits(['change'])

const mileageRules = [(value) => value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0) || 'Unesite cijeli broj od 0 naviše']
const batteryRules = [(value) => value === '' || (Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 100) || 'Unesite cijeli broj od 0 do 100']
const fuelRules = [(value) => String(value ?? '').length <= 50 || 'Najviše 50 znakova']
</script>
